import React from 'react';
import { motion } from 'framer-motion';
import { Button, NeuralBackground } from '../ui';
export const Hero = () => {
  return <section className="relative min-h-[90vh] flex items-center bg-hero-gradient overflow-hidden" data-id="element-159">
      <NeuralBackground data-id="element-160" />
      {/* Decorative large circle */}
      <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] rounded-full bg-purple/20 blur-[100px] pointer-events-none" data-id="element-161" />
      <div className="container mx-auto px-6 relative z-10 py-20" data-id="element-162">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-163">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-164">
            <div className="inline-block border border-gold/30 px-4 py-1.5 mb-6 bg-navy/50 backdrop-blur-sm" data-id="element-165">
              <span className="font-display text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-166">
                NLP & Psihologie Aplicată
              </span>
            </div>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6" data-id="element-167">
              Din blocaj și epuizare, la claritate, energie și încredere reală.
            </h1>
            <p className="font-display text-textSub text-lg md:text-xl leading-relaxed mb-10 max-w-xl" data-id="element-168">
              Un program practic pentru antreprenori, sportivi și lideri care
              știu că pot mai mult, dar se simt blocați mental, obosiți sau fără
              direcție. Prin tehnici moderne de NLP și psihologie aplicată, îți
              recâștigi claritatea și puterea de a acționa.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-169">
              <Button data-id="element-170">Vreau să aflu mai multe</Button>
              <p className="text-xs text-textSub max-w-[200px] font-sans" data-id="element-171">
                Peste 90% dintre cei care au parcurs programul și-au atins
                obiectivele. Locurile sunt limitate.
              </p>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative h-[600px] hidden lg:flex justify-center" data-id="element-172">
            {/* Image with premium dark overlay aesthetic */}
            <div className="relative w-[380px] h-full bg-navy-card border border-gold/20 overflow-hidden" data-id="element-173">
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent z-10" data-id="element-174" />
              <img src="https://cdn.magicpatterns.com/uploads/tt1kHACWj4sW35yoUFmuwi/poza_1.png" alt="Marius Cernea" className="w-full h-full object-cover object-center opacity-90" data-id="element-175" />
            </div>
            {/* Decorative elements around image */}
            <div className="absolute bottom-[-24px] left-[calc(50%-190px-24px)] w-32 h-32 border-l border-b border-gold/50" data-id="element-176" />
            <div className="absolute top-[-24px] right-[calc(50%-190px-24px)] w-32 h-32 border-r border-t border-gold/50" data-id="element-177" />
          </motion.div>
        </div>
      </div>
    </section>;
};